module.exports = __webpack_public_path__ + "img/5_h_no.e05d3ef1.svg";